import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface IssueSummary {
  id: string;
  name?: string;
  uniqueName?: string;
  key?: string;
  displayOrder: number;
  iconKey?: string;
}

export interface GetClaimIssuesQueryArgs {
  claimId: string;
}

export const getClaimIssuesRequest = ({
  claimId,
}: GetClaimIssuesQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/issues`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimIssuesQuery = async (
  args: GetClaimIssuesQueryArgs,
): Promise<BackResponse<IssueSummary[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<IssueSummary[]>>(
      getClaimIssuesRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
